import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, MenuController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP } from '@ionic-native/http/ngx';
import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor, ErrorInterceptor } from './shared/_helpers';
import { PaymentSuccessPageModule } from './shared/modals/payment-success/payment-success.module';
import { PaymentFailPageModule } from './shared/modals/payment-fail/payment-fail.module';
import { TransactionDetailsPageModule } from './shared/modals/transaction-details/transaction-details.module';
import { NotAllowedPageModule } from './shared/modals/not-allowed/not-allowed.module';
import { PrinterOptionsComponent } from './shared/_components/printer-options/printer-options.component';
import { ExternalAppComponent } from './shared/_components/external-app/external-app.component';
import { CanDeactivateGuard } from './shared/_helpers/candeactivate-guard';
import { NewPaymentPage } from './pages/new-payment/new-payment.page';
import { TermsPageModule } from './shared/modals/terms/terms.module';
import { PrivacyPageModule } from './shared/modals/privacy/privacy.module';
import { AddManagerPageModule } from './shared/modals/add-manager/add-manager.module';
import { AddCashierPageModule } from './shared/modals/add-cashier/add-cashier.module';
import { UserPermissionsPageModule } from './shared/modals/user-permissions/user-permissions.module';
import { AppLauncher } from '@ionic-native/app-launcher/ngx';
import { WithdrawTooltipComponent } from './shared/_components/withdraw-tooltip/withdraw-tooltip.component';
import { FilterTransactionsPageModule } from './shared/modals/filter-transactions/filter-transactions.module';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File } from '@ionic-native/file/ngx';
import { RefreshTooltipComponent } from './shared/_components/refresh-tooltip/refresh-tooltip.component';
import { SelectPaymentMethodPageModule } from './shared/modals/select-payment-method/select-payment-method.module';
import { WithdrawalReceiptPageModule } from './shared/modals/withdrawal-receipt/withdrawal-receipt.module';
import { Market } from '@ionic-native/market/ngx';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { SelectAccountsPageModule } from './shared/modals/select-accounts/select-accounts.module';

@NgModule({
  declarations: [
    AppComponent, PrinterOptionsComponent, WithdrawTooltipComponent,
    RefreshTooltipComponent
  ],
  entryComponents: [
    PrinterOptionsComponent, WithdrawTooltipComponent, RefreshTooltipComponent
  ],
  imports: [
            BrowserModule, HttpClientModule, IonicModule.forRoot(
              /* { animated: localStorage.getItem('isCordova') === null ? false : true } */),
            IonicStorageModule.forRoot(), AppRoutingModule, ReactiveFormsModule,
            PaymentSuccessPageModule, PaymentFailPageModule, Ng2SearchPipeModule,
            TransactionDetailsPageModule, NotAllowedPageModule, TermsPageModule,
            PrivacyPageModule, AddManagerPageModule, UserPermissionsPageModule,
            AddCashierPageModule, FilterTransactionsPageModule, WithdrawalReceiptPageModule,
            SelectPaymentMethodPageModule, SelectAccountsPageModule, BrowserAnimationsModule
           ],
  providers: [
    File,
    Market,
    StatusBar,
    FileOpener,
    AppLauncher,
    SplashScreen,
    MenuController,
    SocialSharing,
    CanDeactivateGuard,
    ExternalAppComponent,
    HTTP,
    NewPaymentPage,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
